import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ResetPasswordForm } from '../components/ResetPasswordForm';
import { AuthLayout } from '../components/AuthLayout';
import { Button } from '../components/ui/button';
import { ArrowRight, Check } from 'lucide-react';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [success, setSuccess] = useState<string | null>(null);
  
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
  }, [token, navigate]);

  const handleSuccess = (email: string) => {
    setSuccess(email);
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (!token) {
    return null;
  }

  if (success) {
    return (
      <AuthLayout title="Password Reset Successful" description="Your password has been successfully reset">
        <div className="space-y-6">
          <div className="text-center space-y-4">
            <div className="mx-auto w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <Check className="h-6 w-6 text-green-600" />
            </div>
            <p className="text-sm text-gray-600">
              Your password has been successfully reset. You can now log in with your new password.
            </p>
          </div>

          <div className="text-center">
            <Button 
              onClick={handleBackToLogin}
              className="w-full h-11 text-base font-medium"
            >
              <div className="flex items-center">
                Continue to Login
                <ArrowRight className="ml-2 h-4 w-4" />
              </div>
            </Button>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Set new password" description="Enter your new password below">
      <ResetPasswordForm token={token} onSuccess={handleSuccess} />
    </AuthLayout>
  );
}